"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montefiore-dell-aso": {
    "a7a8e3a6": [{
      "hkey": "72178e9d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "aso": [{
      "hkey": "72178e9d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "43a5e483": [{
      "hkey": "f5aa781e",
      "slug": "montefiore-dell-aso",
      "name": "Montefiore dell'Aso",
      "primary": true,
      "skipSearch": false
    }],
    "menocchia": [{
      "hkey": "f5aa781e",
      "slug": "montefiore-dell-aso",
      "name": "Montefiore dell'Aso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;